import script from "./ItemForm.vue?vue&type=script&lang=ts&setup=true"
export * from "./ItemForm.vue?vue&type=script&lang=ts&setup=true"

import "./ItemForm.vue?vue&type=style&index=0&id=1f4dfb58&lang=scss"

const __exports__ = script;

export default __exports__